import { Maybe, PriceTier, PurchasedProductGuestsPerTier } from "gql/generated";
import { TFunction } from "i18next";
import _ from "lodash";
import pluralize from "pluralize";

const getGuestSummaryString = (
  guests: PurchasedProductGuestsPerTier[],
  priceTiers: PriceTier[] | Maybe<PriceTier>[],
  tFn: TFunction<"booker", undefined>, // This must be the `t` function scoped to the `booker` namespace
): string => {
  const summaryString = _.compact(
    guests.map(g => {
      const fullTier = priceTiers.find(t => t?._id === g.tierId);
      if (g.count > 0) {
        const tierTypeString = tFn(`GUESTS_PAGE.GUEST_TYPES.${fullTier?.type}`);
        return pluralize(tierTypeString ?? "", g.count, true);
      } else return null;
    }),
  ).join(" • ");
  return summaryString.length > 0
    ? summaryString
    : tFn("GUESTS_PAGE.SELECT_GUESTS");
};

export { getGuestSummaryString };
